import service from '@/utils/request'

export function getHfSupplierPage(params) {
  return service.get('/uic-system/supplier/page', {
    params: {
      current: params?.current || 1,
      size: params?.size || 20,
      supplierName: params?.keyword || ''
    }
  })
}
